import xss from "xss";
import MetalItem from "../type/metal-item.js";

export default class MetalStorage {
  constructor(config) {
    let { all, allKinds, allMakes, current, currentKinds, currentMakes, timestamp, maxshipment, maxsum, priceList } = (config || {});
    this.all = Array.isArray(all) ? all : [];
    this.allKinds = allKinds || {};
    this.allMakes = allMakes || {};
    this.priceList = priceList || null;
    this.current = Array.isArray(current) ? current : [];
    this.currentKinds = currentKinds || {};
    this.currentMakes = currentMakes || {};
    this.timestamp = timestamp || null;
    this.maxshipment = maxshipment || 0;
    this.maxsum = maxsum || 0;
  }

  setAll(data) {
    this.all = (data.items || []).map(item => {
      let imageList = item.imageList || [];
      if (
        !Array.isArray(item.imageList) &&
        item.additionalProperties &&
        Array.isArray(item.additionalProperties.imageList)
      ) {
        imageList = item.additionalProperties.imageList;
      }
      return {
        id: xss(item.id),
        kennziffer: Number(String(item.id).replace(/^nm/, "")),
        image: xss(item.image),
        name: xss(item.name),
        text: xss(item.text),
        imageList: imageList.map(xss),
        popularity: Number(
          item.popularity || (
            item.additionalProperties && item.additionalProperties.popularity
              ? item.additionalProperties.popularity
              : "99999"
          )
        )
      };
    });
    this.allKinds = data.kinds || {};
    this.allMakes = data.makes || {};
    this.maxshipment = Number(data.maxshipment);
    this.maxsum = Number(data.maxsum);
    if (this.priceList) {
      this.setAvailable(this.priceList.list, this.priceList.timestamp);
      this.priceList = null;
    }
  }

  setAvailable(list, nTimestamp) {
    if (this.hasNoData()) {
      // store arguments if katalog is not yet loaded
      this.priceList = { list, timestamp: nTimestamp };
      return;
    }
    this.current = [];
    this.currentKinds = {};
    this.currentMakes = {};

    if (!Array.isArray(list)) return;
    this.timestamp = xss(nTimestamp);
    let availById = {};
    let item, props, kind, make, i;
    // creating lists of available items, kinds & makes
    for (i = 0; i < list.length; i++) {
      availById["nm" + list[i].kennziffer] = list[i];
    }
    for (i = 0; i < this.all.length; i++) {
      if (this.all[i].id in availById) {
        props = availById[this.all[i].id];
        // kind
        kind = "other";
        if (props.gold_kz === "1") kind = "gold";
        else if (props.silber_kz === "1") kind = "silver";
        else if (props.platin_kz === "1") kind = "platinum";
        else if (props.palladium_kz === "1") kind = "palladium";
        // make
        make = "other";
        if (props.muenzen_kz === "1") make = "coin";
        else if (props.barren_kz === "1") make = "ingot";
        else if (props.kassetten_kz === "1") make = "casket";
        else if (props.zubehoer_kz === "1") make = "accessory";

        let rchargeKz = !!String(props.rchargeKz).match(/^(true|J)$/i);
        let diffsteuerungKz = !!String(props.diffsteuerungKz).match(/^(true|J)$/i);
        let preissteuerungKz = !!String(props.preissteuerungKz).match(/^(true|J)$/i);

        item = MetalItem.create({
          kennziffer: props.kennziffer,
          id: this.all[i].id,
          name: props.bezeichnung,
          text: this.all[i].text,
          image: this.all[i].image,
          imageList: this.all[i].imageList,
          price: props.preis,
          mwst: props.mwst_prozent,
          kind,
          make,
          amount: 1,
          margin: undefined,
          positionMwst: 0,
          positionDues: 0,
          positionSum: 0,
          popularity: this.all[i].popularity,
          innenProvision: props.innen_provision,
          konditionenProzent: props.konditionen_prozent,
          rchargeKz,
          diffsteuerungKz,
          preissteuerungKz,
          produktInfo: props.produktInfo
        });
        this.currentKinds[kind] = true;
        this.currentMakes[make] = true;
        this.current.push(item);
      }
    }
  }

  getItems() {
    return this.current;
  }

  getQueryItems(query) {
    return (this.current || []).filter(item => {
      return (
        this.isTextMatch(item.name, query) || this.isTextMatch(item.text, query) || this.isTextMatch(item.id, query)
      );
    });
  }

  isTextMatch(txt, query) {
    return txt === ""
      ? false
      : txt.toLowerCase().indexOf(query.toLowerCase()) > -1;
  }

  getKinds() {
    return this.createSelectorModel(this.allKinds, this.currentKinds);
  }

  getMakes() {
    return this.createSelectorModel(this.allMakes, this.currentMakes);
  }

  getCatalogTimestamp() {
    return this.timestamp;
  }

  createSelectorModel(allItems, usedItems) {
    let list = [{ name: "Alle", value: "" }];
    for (let key in allItems) {
      if (key in usedItems) list.push({ name: allItems[key], value: key });
    }
    return list;
  }

  hasNoData() {
    return this.all.length === 0 && this.current.length === 0;
  }

  hasNoAvailable() {
    return this.current.length === 0;
  }

}
